import apiClient from '../service/api'

// GET ALL videos
export const getAllVideos = async (page) => {
  const { data } = await apiClient.get('/v1/movies', {
    params: { page },
  })
  return data
}

export const dummy = null
